const en = {
  translation: {
    menu: "Menu",
    languageNames: {
      english: "English",
      swedish: "Swedish",
    },
    chooseLanguage: "Choose Language",
    topStory: "Todays Top Story",
    password: "Password",
    confirmPassword: "Confirm password",
    submit: "Submit",
    registrationSuccessful: "Registration successful",
    signUp: "Sign Up",
    signIn: "Sign In",
    categories: "Categories",
    signInMessage: "Sign In Successful",
    subscribed: "Subscribe Now",
    becomeASubscriber: "Become a subscriber for only 199 kr per annum.",
  },
};
export default en;
